<template>
    <v-dialog v-model="dialog" max-width="850px" persistent>
        <v-card>
            <v-card-title class="primary white--text title">Edit Row</v-card-title>
            <v-container>
                <div v-for="header in arr" :key="header">
                    <v-text-field v-if="header!='id'" :label="header" v-model="item[header]"></v-text-field>
                    <v-text-field v-if="header=='id'" label="id" v-model="item.id" disabled></v-text-field>
                </div>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn outline class="mr-2" @click="dialog=false">Cancel</v-btn>
                    <v-btn class="primary mr-2 elevation-4" @click="update">Confirm</v-btn>
                </v-card-actions>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        value: {type: Boolean, default: true},
        item: {type: Object, default: null}
    },
    data: function () {
        return {
            activeItem: {},
            arr: ['test'],
            dialog: false
        }
    },
    methods: {
        update() {
            this.$emit('updateItem', this.activeItem)
            this.dialog = false
        }
    },
    watch: {
        value() {
            if (this.item) {
                this.activeItem = this.item
                this.arr = [...new Set([...Object.keys(this.item), 'carnot_name', 'point', 'equip', 'equip_type', 'floor', 'tower', 'unit'])]
            }
            if (this.dialog != this.value) {
                this.dialog = this.value
            }
        },
        dialog() {
            this.$emit('input', this.dialog)
        }
    }
}
</script>

<style>

</style>